import { clsx } from "clsx";
import type { ReactNode } from "react";

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center py-12 text-center",
        className,
      )}
    >
      <div className="rounded-full bg-muted p-4 text-faint">{icon}</div>
      <h3 className="mt-4 text-sm font-semibold text-main">{title}</h3>
      <p className="mt-1 text-sm text-dim">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
